import { useContext, useCallback } from 'react';
import { NotificationContext, Add, Remove, Replace, Clear } from './NotificationProvider';

const variants = {
    INFO: 'info',
    WARNING: 'warning',
    ERROR: 'error',
    SUCCESS: 'success',
    DEFAULT: 'default'
}

const useNotifications = () => {
    const [{ notifications }, dispatch] = useContext(NotificationContext);

    const AddNotification = useCallback(({ title, message, date, variant }) => 
        dispatch(Add({ title, message, date, variant }))
    , [dispatch]);

    const RemoveNotification = useCallback((index) => {
        if(index < 0 || index >= notifications.length)
            return;
        
        dispatch(Remove(index));
    }, [dispatch, notifications.length])

    return {
        notifications,
        variants,
        AddNotification,
        RemoveNotification,
        Clear: () => dispatch(Clear()),
        Replace: (notifications) => dispatch(Replace(notifications))
    }
}

export default useNotifications;